import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  LOCALE_ID,
  inject,
  input,
  untracked,
  viewChild,
  viewChildren
} from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLinkDetectorDirective } from 'app/core/directives/router-link-detector.directive';
import { Link } from 'app/core/models/link.model';
import { Navmenu } from 'app/core/models/nav-menu.model';
import { LanguageService } from 'app/shared/services/language.service';
import { wait } from '../../utils/wait';
import { ShebaFooterLinksComponent } from '../footer-links/footer-links.component';
import { ShebaDrawerComponent } from './drawer.component';
import { ShMenuItemComponent } from './menu-item.component';

@Component({
  selector: 'sheba-sidenav',
  exportAs: 'sidenav',
  templateUrl: 'sidenav.component.html',
  styleUrls: ['sidenav.component.scss'],
  imports: [
    MatSidenavModule,
    NgTemplateOutlet,
    ShebaDrawerComponent,
    NgClass,
    MatRippleModule,
    ShMenuItemComponent,
    ShebaFooterLinksComponent,
    TranslateModule,
    RouterLinkDetectorDirective
  ],
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShebaSidenavComponent {
  constructor(protected languageService: LanguageService) {}
  readonly menu = input<Navmenu[] | undefined>([]);
  termsOfUseLink = input<Link>();
  sitesPolicyLink = input<Link>();
  allRightsReservedLink = input<Link>();
  accessibilityStatementLink = input<Link>();

  readonly sidenav = viewChild.required(MatSidenav);
  readonly drawers = viewChildren<ShebaDrawerComponent<Navmenu>>(ShebaDrawerComponent);

  readonly local = inject(LOCALE_ID);

  private readonly cd = inject(ChangeDetectorRef);

  toggle() {
    if (untracked(this.sidenav).opened) {
      this.closeAll();
    } else {
      untracked(this.sidenav).open();
    }
    this.cd.markForCheck();
  }

  async closeAll() {
    untracked(this.sidenav).close();
    await wait(0);
    const drawers = untracked(this.drawers);
    for (const drawer of drawers) {
      drawer.close();
    }
  }
}
